import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import Firebase from 'firebase/app'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

Vue.prototype.$firebase = Firebase

Firebase.auth().onAuthStateChanged((user) => {
  store.commit('setUser', user)
  if (user) {
    store.dispatch('users/openDBChannel').then((something) => {
      // console.log(something)
    })
  }
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
